import script from "./Remessas.vue?vue&type=script&setup=true&lang=ts"
export * from "./Remessas.vue?vue&type=script&setup=true&lang=ts"

import "./Remessas.vue?vue&type=style&index=0&id=296ce6f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296ce6f4"]])

export default __exports__